<template lang="html">
    <section class="whisprDemo">
        <div class="Vlt-grid">
            <div class="Vlt-col Vlt-col--A-1of3">
                <b>Send a Whispir message</b>
                <vlt-field label="From">
                    <vlt-input disabled :val="fromNumber" />
                </vlt-field>

                <vlt-field label="Text">
                    <vlt-input textarea id="textmessage" :rows="4" v-model="message" placeholer="Sample"
                        :val="message" />
                </vlt-field>

                <vlt-field label="To">
                    <vue-phone-number-input color="#131415" :no-validator-state="false"
                        :default-country-code="nexmo.region" v-model="prettyNumber" @update="onUpdate" />
                </vlt-field>
                <br />
                <vlt-button label="Send" secondary app @click="sendText" :disabled="(!message) || (!isValid)" />
            </div>

            <div class="Vlt-col Vlt-col--A-2of3">
                <b>Delivery/Status messages</b>
                <div class="Vlt-table Vlt-table--short" data-sortable style="padding-bottom: 1px;">
                    <table>
                        <thead>
                            <tr>
                                <th>Time</th>
                                <th>To</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in delivery">
                                <td>{{ item.timestamp }}</td>
                                <td>{{ item.to }}</td>
                                <td>{{ item.status }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="js">
import {
    $HTTPDEMO
} from '../services/nidsService.js';
import Pusher from "pusher-js";
import {
    parsePhoneNumberFromString
} from 'libphonenumber-js';
import axios from 'axios';

import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,

} from "@vonagevolta/vue";

export default {
    name: 'whisprDemo',
    data() {
        return {
            //            message: 'Hello, ' + this.nexmo.firstname + ' ' + this.nexmo.lastname + ', Click: https://showcase.au.whispir.com/portal/richmessage/qkFDmYc3/v.prtl',
            message: 'Hello, ' + this.nexmo.firstname + ' ' + this.nexmo.lastname + ', Click: https://click.us.whispir.com/s/bdlkueiE',
            number: '',
            prettyNumber: '',
            numberStuff: {},
            delivery: [],
            fromNumber: '',
            isValid: true,
            pusher: {},
        }
    },
    props: {
        nexmo: {
            type: Object,
            required: false
        }
    },
    methods: {
        sendText() {
            console.log("To " + this.number + " we send: " + this.message);
            $HTTPDEMO.post('whisprDemo.php/send', {
                to: this.number,
                message: this.message,
            });
            this.$swal('Success',
                'The Whispir Message will be sent to ' + this.numberStuff.formatInternational + '.',
                'success');
        },
        register() {
            console.log("Registering the Demo Component with the associated backend");
            //            $HTTPDEMO.post('smsDemo.php/register', {});
        },
        onUpdate(payload) {
            console.log("Whispir: Got onUpdate");
            this.numberStuff = payload;
            this.isValid = payload.isValid;
            if (payload.isValid) {
                this.number = this.numberStuff.formattedNumber.replace(/\D/g, '');;
            } else {
                var test = parsePhoneNumberFromString(payload.formattedNumber);
                console.log("Re-checked number: ", test)
                if (test.isValid()) {
                    this.isValid = true;
                    this.number = test.number.replace(/\D/g, '');
                    console.log("new this.number = ", this.number)
                } else {
                    this.isValid = false;
                }
            }
        },

    },
    components: {
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput,
    },
    created() {
        this.register();
        this.fromNumber = parsePhoneNumberFromString("+" + this.nexmo['from']).formatInternational();
        this.prettyNumber = parsePhoneNumberFromString("+" + this.nexmo['phone']).formatNational();
        this.onUpdate({
            isValid: true,
            formatInternational: this.nexmo['phone'],
            formattedNumber: this.nexmo['phone']
        });
        this.pusher = new Pusher(this.nexmo['pusher_key'], { //Pusher Key
            cluster: 'us3',
            forceTLS: true
        });
        let channel = this.pusher.subscribe("whispr");
        channel.bind("delivery_" + this.nexmo.userid, data => {
            console.log("Got some whispir data: " + JSON.stringify(data));
            this.delivery.unshift(data);
        });
        console.log(this.nexmo);
    },
    beforeDestroy() {
        console.log("beforeDestroy for whispirDemo")
        if (this.pusher) {
            this.pusher.unsubscribe("whispr");
        }
    },
}
</script>

<style scoped lang="scss"></style>
